import { Checkbox as MUICheckbox } from '@mui/material'
import type { SxProps } from '@mui/material'

interface ICheckboxProps {
  checked?: boolean
  onChange?: (newValue: boolean) => void
  disabled?: boolean
  size?: 'small' | 'medium'
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'default'
  sx?: SxProps
}

export default function Checkbox({
  checked,
  onChange,
  disabled,
  size = 'medium',
  color = 'primary',
  sx,
}: ICheckboxProps) {
  return (
    <MUICheckbox
      checked={checked}
      onChange={(_event, newValue) => onChange?.(newValue)}
      disabled={disabled}
      size={size}
      color={color}
      sx={sx}
    />
  )
}
